<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <div class="titlePu">
      <div>公共图书馆</div>
    </div>
    <div class="commonLiContainer">
      <div class="Comcontainer">
        <div class="TopConTwo">
          <div class="LeftDiv">
            <el-row :gutter="10">
              <el-col :span="8" @click.native="ActiveClick(10128,'历史与地理')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/swAYaJiV5.jpg">
                  <span>历史与地理</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10129,'励志与成功')">
                <div class="wrap">
                  <img src="http://img3.winxuancdn.com/0868/1203370868_0_1_800x800.jpg?1722561502118">
                  <span>励志与成功</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10130,'艺术美学')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/wzNh3FCA9.jpg">
                  <span>艺术美学</span>
                </div>
              </el-col>          
              <el-col :span="8" @click.native="ActiveClick(10131,'生活万花筒')">
                <div class="wrap">
                  <img src="http://img1.winxuancdn.com/4146/1203404146_0_1_800x800.jpg?1725418094951">
                  <span>生活万花筒</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10132,' 暖心童绘')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/5V6ZMzR57.jpg">
                  <span>暖心童绘</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10133,'热门畅销')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/DALvt9N5y.jpg">
                  <span>热门畅销</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10134,'畅销文学')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/q0FHg0q5t.jpg">
                  <span>畅销文学</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10135,'党旗飘扬')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/1xG2Bgull.jpg">
                  <span>党旗飘扬</span>
                </div>
              </el-col>
              <el-col :span="8" @click.native="ActiveClick(10136,'抗战80周年')">
                <div class="wrap">
                  <img src="https://newcover.ytzhihui.com/newcover/erp/bls/19qqr0qeH.jpg">
                  <span>抗战80周年</span>
                </div>
              </el-col>
            </el-row>
            <div class="xueke">
              <div class="title">大众分类</div>
              <div class="xuekeDiv" v-for="(item, index) in xuekeFenlei" :key="0 + index">
                <div class="xuekeTitle" @click="AllClick(item)">{{item.type_name}}</div>
                <div class="xuekeContent">
                  <span class="spanOneItem" v-for="(item, index1) in item.child" :key="1 + index1"
                    @click="AllClick(item)">
                    {{item.type_name}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="xueke-gg">
            <div class="title">中图分类</div>
            <div class="chinesDataStyle" v-for="(item, index) in ChinesData" :key="index" @click="ChinesClick(item)">
              {{item.classifyTypeCode}}、{{item.classifyTypeName}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { listpopularTypes, listclassifyTypes } from '@/api/img'
  import { getApiData } from '@/api/pages'

  import Cookies from 'js-cookie'
  import Axios from "@/api/diyaxios";
  
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
        // 学科分类
        xuekeFenlei: [],
        // 中图分类
        ChinesData: []
      }
    },
    mounted() {
      this.ApiData()
      this.ApiDataChine()
    },
    methods: {
      // 通俗分类[大众分类]数据
     async ApiData() {
        let data = {}
            let res = await getApiData(data)
            if(res.code == '200'){
              this.xuekeFenlei = res.data
            }
      },
      // 中图分类数据
     async ApiDataChine() {
        let data = {
          classifyLevel:1,
        }
            let res = await listclassifyTypes(data)
            if(res.code == '200'){
              this.ChinesData = res.data
            } 
      },
      // 5少儿专区/6推荐书单/7工具书/经典珍藏8/重磅推荐9/乐活趣览10
      ActiveClick(activityTag, TitleName) {
          let params = {
              gid:'0',
            TitleName: TitleName,
            publicType: '', // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: '', // 学科类别
            activityTag: activityTag, // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: 1
          };
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: {obj: JSON.stringify(params)}
        })
      },
      // 大众分类
      AllClick(item) {
        let params = {
            gid:'0',
            title: item.type_name,
            publicType: item.type_code, // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: 1
          };
        this.$router.push({
          name: 'LookPublishingPagesType',
          query:{obj: JSON.stringify(params)}
        })
      },
      // 中图分类
      ChinesClick(item) {
        let params = {
            gid:'0',
            zttitle: item.classifyTypeName,
            publicType: '', // 大众分类
            cnIbraryType: item.classifyTypeCode, // 中图分类
            subjectId: '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: 1
          };
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: {obj: JSON.stringify(params)}
        })
      }
    },
    components: {
      BottomComponent,
      TopComponent
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1、title */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 公共 */
  .commonLiContainer {
    width: 1200px;
    margin-left: calc(50% - 600px);
  }

  .Comcontainer {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 0px;
  }

  .title {
    height: 50px;
    line-height: 50px;
    margin-left: 15px;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    text-align: left;
    font-family: PingFang-SC-Bold;
  }

  .wrap {
    display: flex;
    align-items: center;
    padding: 12px;
    margin-bottom: 10px;
    border-radius: 10px;
    color: #666;
    font-size: 16px;
    font-weight: bold;
    font-family: PingFang-SC-Bold;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.04);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    overflow: hidden;
  }

  .wrap img {
    // width: 80px;
    height: 80px;
    margin-right: 16px;
  }

  /* 2 */
  .TopConTwo {
    width: 100%;
    margin-top: 20px;
    font-size: 0px;
  }

  .LeftDiv {
    width: calc(80% - 20px);
    display: inline-block;
  }

  /* 2、1 */
  .xueke {
    width: 100%;
    /* height: 731px; */
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  }

  .xuekeDiv {
    width: 100%;
    border-bottom: 1px solid rgba(226, 226, 226, 1);
    padding: 15px 0px;
    position: relative;
  }

  .xuekeTitle {
    width: 100px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFang-SC-Bold;
    display: inline-block;
    position: absolute;
    left: 15px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    cursor: pointer;
  }

  .xuekeContent {
    width: calc(100% - 120px);
    margin-left: 120px;
    height: 30px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    display: inline-block;
  }

  .xuekeContent .spanOneItem {
    display: inline-block;
    /* width: 16.6%; */
    padding: 0px 20px;
    line-height: 30px;
  }

  .xuekeContent .spanOneItem:hover {
    color: #175199;
    cursor: pointer;
  }

  .xuekeContent .spanTwoItem {
    width: 100%;
    background-color: rgba(249, 249, 249, 1);
    margin-top: 20px;
  }

  .childrensStyle {
    padding: 0px 20px;
    display: inline-block;
    line-height: 30px;
  }

  /* 2、2 */
  .xueke-gg {
    width: 20%;
    height: 731px;
    margin-left: 10px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    display: inline-block;
    vertical-align: top;
  }

  .chinesDataStyle {
    padding: 5px 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .chinesDataStyle:hover {
    color: #175199;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/common-Library.vue